import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import OperateTabs from "examples/Tabs/OperateTabs";

function Operate() {
  return (
    <DashboardLayout>
      <OperateTabs />
    </DashboardLayout>
  );
}

export default Operate;